export const EDIT_USER = 'EDIT_USER'
export const EDIT_SESSION = 'EDIT_SESSION'
export const EDIT_COLOR = 'EDIT_COLOR'



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js